import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { AuthTokenService } from '../core/services/app-auth-token.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(AuthTokenService);

  const addToken = (request: HttpRequest<unknown>): HttpRequest<unknown> => {
    const token = tokenService.getAuthorizationToken();
    return token
      ? request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : request;
  };

  const executeRequest = (): Observable<HttpEvent<unknown>> =>
    next(addToken(req)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return from(tokenService.refreshToken()).pipe(switchMap(() => next(addToken(req))));
        }
        return throwError(() => error);
      }),
    );

  if (!req.url.startsWith('assets/') && tokenService.isTokenExpired()) {
    return from(tokenService.refreshToken()).pipe(switchMap(() => executeRequest()));
  }

  return executeRequest();
};
